import React from 'react';
import type { UseFormRegister, Path, FieldValues } from 'react-hook-form';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { withOpacity } from '@cineamo/ui/src/helpers/color-helper';

export type FormSelectOption = {
    value: string;
    label: string;
};

type FormSelectProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    register: UseFormRegister<T>;
    registerOptions?: Parameters<UseFormRegister<T>>[1];
    options: FormSelectOption[];
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    domainConfiguration: DomainConfigurationDto;
};

export default function FormSelect<T extends FieldValues>({
    name,
    label,
    register,
    registerOptions,
    options,
    placeholder,
    required = false,
    disabled = false,
    domainConfiguration
}: FormSelectProps<T>) {
    return (
        <div className="space-y-3">
            <label
                className="block text-body-14 font-semibold"
                style={{ color: domainConfiguration.style.onSurfaceColor }}>
                {label} {required && '*'}
            </label>
            <select
                {...register(name, registerOptions)}
                disabled={disabled}
                className="w-full p-3 border rounded-8 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[var(--focus-ring-color)] disabled:opacity-50"
                style={
                    {
                        borderColor: withOpacity(domainConfiguration.style.onSurfaceColor, 0.3),
                        backgroundColor: domainConfiguration.style.surfaceColor,
                        color: domainConfiguration.style.onSurfaceColor
                    } as React.CSSProperties
                }>
                {placeholder && <option value="">{placeholder}</option>}
                {options.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
